import { getAuth } from "firebase/auth";

const getApiUrl = (functionName) => `https://europe-west3-bifrostkey.cloudfunctions.net/${functionName}`;

export const callApi = async (functionName, data) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error("User not authenticated.");
  }

  const token = await user.getIdToken();

  const response = await fetch(getApiUrl(functionName), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    cache: 'no-cache', // Prevent browser caching
    body: JSON.stringify({ data }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`API call failed with status ${response.status}: ${errorText}`);
  }

  const result = await response.json();
  return result.data;
};
